import React from 'react';

export function useFields(fieldsArr) {
  const fieldsRefs = {};
  for (const fieldName of fieldsArr) {
    fieldsRefs[fieldName] = React.createRef(null);
  }
  return fieldsRefs;
}
